import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Users } from "lucide-react";
import API_BASE_URL from "../config/Config.js";
import { PageLoader } from "./ui";

const mockData = [
  {
    id: "1",
    name: "Секеров Алибек Жайлаубаевич",
    image_url: "/images/team/170A7179_resized.jpg",
    extra_role: "Генеральный директор Учреждения адвокатской конторы \"Sekerov&partners\""
  },
  {
    id: "2",
    name: "Шакиржанов Руслан Сейпиевич",
    image_url: "/images/team/170A7345_resized.jpg",
    extra_role: "Специалист системы менеджмента и качества КазНУИ \"ШАБЫТ\""
  },
  {
    id: "3",
    name: "Баубериков Газиз Жолдасбекович",
    image_url: "/images/team/170A7127_resized.jpg",
    extra_role: "директор института Стратегических гуманитарных исследований АВН РК"
  },
  {
    id: "4",
    name: "Ғабдолла Алишер Найманұлы",
    image_url: "/images/team/170A7098_resized.jpg",
    extra_role: "Учредитель \"Nai Production\""
  },
  {
    id: "5",
    name: "Еликбаева Алтынай Талгатовна",
    image_url: "/images/team/IMG_5146.JPG",
    extra_role: ""
  },
  {
    id: "6",
    name: "Алмажанова Кульзат Каналхановна",
    image_url: "/images/team/IMG_5154.JPG",
    extra_role: "Председатель ОО \"Жасыл Желкен\""
  },
  {
    id: "7",
    name: "Замзагуль Есенова",
    image_url: "/images/team/IMG_5144.JPG",
    extra_role: "Автор и ведущий трансформационных игр, предприниматель."
  },
  {
    id: "8",
    name: "Сұлушаш Сетейқызы",
    image_url: "/images/team/IMG_5134.JPG",
    extra_role: "дизайнер"
  },
  {
    id: "9",
    name: "Хамитова Анар Дуйсенбайкызы",
    image_url: "/images/team/IMG_5143.JPG",
    extra_role: "Специалист по связям с общественностью"
  },
  {
    id: "10",
    name: "Арайлым Рахымқызы",
    image_url: "/images/team/IMG_5135.JPG",
    extra_role: "Специалист по связям с общественностью"
  },
  {
    id: "11",
    name: "Асембай Лаура Муратқызы",
    image_url: "/images/team/IMG_5155.JPG",
    extra_role: "Hairstylist"
  },
  {
    id: "12",
    name: "Ақерке Жомартқызы",
    image_url: "/images/team/IMG_5147.JPG",
    extra_role: "ИП \"Бес Асыл\" - Учитель математики"
  },
  {
    id: "13",
    name: "Бауберикова Алла Александровна",
    image_url: "/images/team/IMG_5149.JPG",
    extra_role: ""
  },
];

export default function TeamPage() {
  const [teamMembers, setTeamMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_BASE_URL}/users/workers/`)
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        
        if (data?.data && data.data.length > 0) {
          setTeamMembers(data.data);
        } else {
          setTeamMembers(mockData);
        }
      })
      .catch((err) => {
        console.error("Ошибка загрузки команды:", err);
        setTeamMembers(mockData);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <PageLoader />;
  }

  const getMemberName = (member) => {
    return member.name || `${member.first_name || ''} ${member.last_name || ''}`.trim() || 'Участник команды';
  };

  return (
    <div className="min-h-screen bg-dark-50">
      {/* Header band */}
      <div className="relative overflow-hidden bg-gradient-hero pt-32 pb-20 px-6">
        <div className="pointer-events-none absolute -top-24 -left-24 w-72 h-72 bg-primary-400/30 rounded-full blur-3xl animate-float-slow" />
        <div className="pointer-events-none absolute -bottom-24 -right-16 w-80 h-80 bg-teal-400/20 rounded-full blur-3xl animate-float" />

        <div className="relative max-w-4xl mx-auto text-center">
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="inline-flex items-center gap-2 px-4 py-1.5 mb-4 text-sm font-semibold tracking-wide uppercase rounded-full bg-white/15 text-white backdrop-blur-sm"
          >
            <Users className="w-4 h-4" />
            Люди, которые меняют мир
          </motion.span>
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-3xl md:text-4xl font-bold text-white"
          >
            Наша команда
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="mt-3 text-white/80 max-w-xl mx-auto"
          >
            Профессионалы, объединённые общей целью — сделать мир лучше.
          </motion.p>
        </div>
      </div>

      {/* Team Grid */}
      <div className="max-w-7xl mx-auto px-6 -mt-10 pb-20 relative z-10">
        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {teamMembers.map((member, index) => (
            <motion.div
              key={member.id}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.05 }}
              className="group"
            >
              <div className="relative bg-white rounded-2xl overflow-hidden shadow-card hover:shadow-card-hover transition-all duration-500 transform hover:-translate-y-2">
                {/* Image */}
                <div className="relative h-72 overflow-hidden">
                  <img
                    src={member.image_url}
                    alt={getMemberName(member)}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                    onError={(e) => {
                      e.target.src = "https://via.placeholder.com/300x400?text=Фото";
                    }}
                  />
                  {/* Gradient overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-dark-900/80 via-dark-900/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

                </div>

                {/* Content */}
                <div className="p-5">
                  <h3 className="text-lg font-bold text-dark-900 mb-1 line-clamp-1 group-hover:text-primary-600 transition-colors">
                    {getMemberName(member)}
                  </h3>
                  {member.extra_role && (
                    <p className="text-sm text-dark-500 line-clamp-2">
                      {member.extra_role}
                    </p>
                  )}
                </div>

                {/* Decorative corner */}
                <div className="absolute top-0 right-0 w-16 h-16 bg-gradient-to-br from-primary-500/20 to-teal-500/20 rounded-bl-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
